<app-bringoz-data-table [uniqueId]="tableUniqueId"
                        [defaultWidths]="defaultWidths"
                        [items]="reports"
                        [rowHeight]="rowHeight"
                        [resizable]="true"
                        [hideWhenEmpty]="true">

  <ng-template tableHeader>
    <!-- col-name is pinned left by TableColumnManager - renaming it unpins the Name column. -->
    <div class="th col-name text-ellipsis">{{ 'Name' | translate }}</div>
    <div class="th col-template text-ellipsis">{{ 'Template' | translate }}</div>
    <div class="th col-status text-ellipsis">{{ 'Status' | translate }}</div>
    <div class="th col-branch-group text-ellipsis">{{ 'Branch Group' | translate }}</div>
    <div class="th col-branches text-ellipsis">{{ 'Branches' | translate }}</div>
    <div class="th col-total-jobs text-ellipsis">{{ 'Total Jobs' | translate }}</div>
    <div class="th col-total-routes text-ellipsis">{{ 'Total Routes' | translate }}</div>
    <div class="th col-published-routes text-ellipsis">{{ 'Published Routes' | translate }}</div>
    <div class="th col-dispatched-routes text-ellipsis">{{ 'Dispatched Routes' | translate }}</div>
    <div class="th col-created-by text-ellipsis">{{ 'Created By' | translate }}</div>
    <div class="th col-role text-ellipsis">{{ 'Role' | translate }}</div>
  </ng-template>

  <ng-template tableRow let-report>
    <div class="tr layout-row layout-align-start-center">

      <!--Name-->
      <div class="td col-name layout-row layout-align-start-center">
        <app-bringoz-state-link class="flex text-ellipsis"
                                [state]="'scheduling-project.visit-plan'"
                                [params]="{id: report.visitPlanId}"
                                [text]="report.name">
        </app-bringoz-state-link>
        <app-visit-plan-info-tooltip class="margin-left-5"
                                     [visitPlan]="report">

        </app-visit-plan-info-tooltip>
      </div>

      <!--Template-->
      <div class="td col-template layout-row layout-align-start-center">
        <span class="br-body-2 gray-103 text-ellipsis">{{ report.schedulingProjectTemplateReference?.name }}</span>
      </div>

      <!--Status-->
      <div class="td col-status layout-row layout-align-start-center">
        <span *ngIf="report.statusLabel"
              class="report-status-group br-body-2"
              [ngClass]="report.status">
          {{report.statusLabel}}
        </span>
      </div>

      <!--Branch Group-->
      <div class="td col-branch-group layout-row layout-align-start-center">
        <span *ngIf="report.groupReferences?.length"
              class="br-body-2 gray-103 text-ellipsis"
              [ngbTooltip]="groupNamesTooltip"
              openDelay="300"
              triggers="hover"
              container="body">
          {{report.groupReferences[0].name}}
          <ng-container *ngIf="report.groupReferences.length > 1"> +{{report.groupReferences.length - 1}}</ng-container>
        </span>

        <ng-template #groupNamesTooltip>
          <div class="layout-column">
            <span class="br-body-2" *ngFor="let group of report.groupReferences">{{group.name}}</span>
          </div>
        </ng-template>
      </div>

      <!--Branches-->
      <div class="td col-branches layout-row layout-align-start-center">
        <branches-indicator *ngIf="report.branchReferences?.length"
                            [branches]="report.branchReferences">
        </branches-indicator>
      </div>

      <!--Total Jobs-->
      <div class="td col-total-jobs layout-row layout-align-start-center">
        <span class="br-body-2 gray-103 text-ellipsis">{{ report.totalJobs || 0 }}</span>
      </div>

      <!--Total Routes-->
      <div class="td col-total-routes layout-row layout-align-start-center">
        <span class="br-body-2 gray-103 text-ellipsis">{{ report.totalRoutes || 0 }}</span>
      </div>

      <!--Published Routes-->
      <div class="td col-published-routes layout-row layout-align-start-center">
        <span class="br-body-2 gray-103 text-ellipsis">{{ report.publishedRoutes || 0 }}</span>
      </div>

      <!--Dispatched Routes-->
      <div class="td col-dispatched-routes layout-row layout-align-start-center">
        <span class="br-body-2 gray-103 text-ellipsis">{{ report.dispatchedRoutes || 0 }}</span>
      </div>

      <!--Created By-->
      <div class="td col-created-by layout-row layout-align-start-center">
        <span *ngIf="report.creator"
              class="br-body-2 gray-103 text-ellipsis"
              [ngbTooltip]="report.creator"
              openDelay="300"
              triggers="hover"
              container="body">
          {{report.creator}}
        </span>
      </div>

      <!--Role-->
      <div class="td col-role layout-row layout-align-start-center">
        <span *ngIf="report.creatorRole"
              class="br-body-2 gray-103 text-ellipsis"
              [ngbTooltip]="report.creatorRole"
              openDelay="300"
              triggers="hover"
              container="body">
          {{report.creatorRole}}
        </span>
      </div>

    </div>
  </ng-template>

  <app-empty-state tableEmptyState
                   src="assets/images/empty_state/empty_state_routes.png"
                   text="No Reports Found">
  </app-empty-state>

</app-bringoz-data-table>
